import { useState } from 'react';
import { useEditorContext } from '../contexts/editor';
import { useEditorEventHandler } from './useEditorEventHandler';
import { FocusChangeListenerEvent } from '../types';

export const useFocusState = () => {
  const { editor } = useEditorContext();

  const getFocusStateFromEditor = () => !!editor?.hasFocus();
  const [isFocused, setIsFocused] = useState(getFocusStateFromEditor());
  useEditorEventHandler(Object.values(FocusChangeListenerEvent), () =>
    // Sync React state any time editor state updates
    setIsFocused(getFocusStateFromEditor()),
  );

  const focus = () => {
    editor?.focus();
  };

  return {
    isFocused,
    focus,
  };
};
